import request from '@api';
import { ApiPath, RespCode } from '@constants';
// import { MOCK_POLICY_DETAIL } from './mock';

export const getPolicyDetailData = async (body) => {
  try {
    const resp = await request(ApiPath.Path.PolicyDetail, {
      path: ApiPath.Service.MerchantOpenPlatform,
      method: 'POST',
      body,
    });
    // const resp = MOCK_POLICY_DETAIL;

    const { code, data } = resp || {};

    if (code !== RespCode.Success || !data) {
      console.log(`getPolicyDetailData error, code=${code}, data=${JSON.stringify(data)}`);
      return null;
    }

    return data;
  } catch (error) {
    console.log('getPolicyDetailData error', error);
    return null;
  }
};
